module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0102.jpg?v=2032b77e";